<template>
  <div class="topevent-listing">
    <vs-row class="mb-8">
      <vs-col vs-w="12">
        <div class="float-right flex">
          <vs-button
            color="warning"
            type="filled"
            class="btn-color"
            icon-pack="feather"
            icon="icon-filter"
            @click="showfilter = !showfilter"
            >{{ $t("labels.filter") }}</vs-button
          >
          <vs-button
            color="dark"
            type="filled"
            icon-pack="feather"
            icon="icon-upload"
            class="btn-color ml-4"
            @click.prevent="exportCsv()"
            >{{ $t("labels.export") }}</vs-button
          >
        </div>
      </vs-col>
    </vs-row>
    <vx-card class="filter-card mb-6" v-show="showfilter === true">
      <div class="vx-row filter-default">
        <div class="vx-col sm: w-full md:w-1/3">
          <label class="pl-1">{{ $t("labels.search") }}</label>
          <vs-input
            icon-pack="feather"
            icon="icon-search"
            v-model="search"
            class="w-full"
          />
        </div>
        <div class="vx-col sm: w-full md:w-1/3">
          <label class="pl-1">{{ $t("labels.service") }}</label>
          <v-select
            v-model="service"
            :options="services_drop"
            :reduce="(services_drop) => services_drop.id"
            label="name"
            name="sections"
            class="filter-dropdown"
          />
        </div>
        <div class="vx-col sm: w-full md:w-1/3">
          <label class="pl-1">{{ $t("labels.type") }}</label>
          <v-select
            v-model="type"
            :options="types"
            :reduce="(types) => types.value"
            label="name"
            name="sections"
            class="filter-dropdown"
          />
        </div>
        <div class="vx-col sm: w-full md:w-1/3 flex mt-5">
          <vs-button
            color="primary"
            type="filled"
            icon-pack="feather"
            icon="icon-filter"
            :title="$t('labels.filter')"
            @click.prevent="filter()"
            class="sm:ml-0 md:ml-4 px-10 btn-color fltr-btn"
            >{{ $t("labels.filter") }}
          </vs-button>
          <vs-button
            color="maroon"
            type="filled"
            icon-pack="feather"
            icon="icon-x"
            :title="$t('labels.filter')"
            @click="clearFilter()"
            :disabled="!this.search && !this.service && !this.type"
            class="sm:ml-0 md:ml-4 px-10 btn-color fltr-btn"
            >{{ $t("labels.clear") }}</vs-button
          >
        </div>
      </div>
    </vx-card>
    <vx-card :title="$t('labels.qualification_officers')" class="lead-listing">
      <div class="vx-row w-full m-0 list-header">
        <div
          class="vx-col sm: w-1/2 md:w-1/2 mb-4 set_limit pl-0 pr-0 justify-between"
        >
          <div class="set flex">
            <label class="limit_label">{{ $t("labels.show") }}</label>
            <v-select
              v-model="limit"
              :options="limitarr"
              :reduce="(limitarr) => limitarr.value"
              :clearable="false"
              label="text"
              class="px-1"
            />
            <label class="limit_label">{{
              $t("labels.qualification_officers")
            }}</label>
          </div>
        </div>
        <div
          class="vx-col sm: w-1/2 md:w-1/2 pl-0 pr-0 justify-flex-end addbtn-col mb-6"
        >
          <router-link :to="{ name: 'AddOfficers' }">
            <vs-button
              color="primary"
              type="filled"
              icon-pack="feather"
              icon="icon-plus"
              class="float-right btn-add sm: mb-4 md:m-0"
              v-if="checkPermission('qualification-officers', 'add')"
              >{{ $t("labels.add_qualification_officer") }}</vs-button
            >
          </router-link>
        </div>
      </div>

      <vs-table :data="officers" class="permission">
        <template slot="thead">
          <vs-th class="col-md-2">{{ $t("labels.name") }}</vs-th>
          <vs-th class="col-md-2">{{ $t("labels.description") }}</vs-th>
          <vs-th class="col-md-2">{{ $t("labels.type") }}</vs-th>
          <vs-th class="col-md-2">{{ $t("labels.service") }}</vs-th>
          <vs-th class="col-md-2">{{ $t("labels.officer_sequence") }}</vs-th>
          <vs-th class="col-md-2">{{ $t("labels.action") }}</vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="tr.name">{{ tr.name }}</vs-td>
            <vs-td :data="tr.name">{{ tr.description }}</vs-td>
            <vs-td :data="tr.name">{{ tr.type_name }}</vs-td>
            <vs-td :data="tr.name">{{
              tr.service ? tr.service.name : "-"
            }}</vs-td>
            <vs-td :data="tr.name">{{ tr.display_number }}</vs-td>
            <vs-td width="125">
              <div class="flex">
                <vs-button
                  type="flat"
                  :title="$t('labels.edit')"
                  size="large"
                  icon-pack="feather"
                  icon="icon-edit"
                  color="success"
                  class="mr-2"
                  @click="
                    $router.push({
                      name: 'EditOfficers',
                      params: { id: tr.id },
                    })
                  "
                  v-if="checkPermission('qualification-officers', 'modify')"
                ></vs-button>

                <vs-button
                  @click="deleteConfirm(indextr)"
                  type="flat"
                  :title="$t('labels.delete')"
                  size="large"
                  icon-pack="feather"
                  icon="icon-trash-2"
                  color="danger"
                  v-show="
                    tr.status !== 'W' &&
                    checkPermission('qualification-officers', 'delete')
                  "
                ></vs-button>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <div class="mt-6">
        <vs-pagination
          color="dark"
          :total="totalPage"
          v-model="currentx"
          class="mb-1"
        ></vs-pagination>
      </div>
    </vx-card>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      officers: [],
      totalPage: 1,
      currentx: 1,
      limit: parseInt(process.env.VUE_APP_PER_PAGE),
      // limit: this.$store.state.limit,
      showfilter: false,
      search: null,
      service: "",
      services_drop: [],
      types: [
        { name: "Qualification Officer", value: "QO" },
        { name: "Qualification Engineer", value: "QE" },
      ],
      type: "",
    };
  },
  computed: {},
  watch: {
    showfilter(val) {
      if (val == true) {
        this.getServices();
      }
    },
    limit(val) {
      // this.$store.state.limit = val
      localStorage.setItem("limit", val);
      this.currentx = 1;
      this.getOfficers();
    },
    currentx(val) {
      this.getOfficers();
    },
  },
  mounted() {
    if (localStorage.getItem("limit")) {
      this.limit = localStorage.getItem("limit");
    }
    // this.getServices();
    this.getOfficers();
  },
  methods: {
    async getOfficers(exp = false) {
      let input = {
        page: this.currentx,
        perPage: this.limit,
        search: this.search,
        service: this.service,
        type: this.type,
      };
      if (exp) {
        input = Object.assign(input, {
          export: true,
          page: 1,
          perPage: 0,
        });
      }
      let response = await this.getHTTPPostResponse(
        "/qualifications/list",
        input
      );
      if (exp) {
        this.exportFile(response, "Officers");
      }
      if (!exp) {
        if (response) {
          let data = response.data;
          let officers = data.qualification_role;
          let perPage = this.limit;
          let totalPage = Math.ceil(response.data.count / perPage);
          this.totalPage = totalPage;
          this.officers = officers;
        }
      }
    },
    deleteConfirm(index) {
      this.index = index;
      this.$vs.dialog({
        type: "confirm",
        color: "rgba(var(--vs-primary),1)",
        title: this.$t("labels.confirmation"),
        acceptText: this.$t("labels.yes"),
        cancelText: this.$t("labels.no"),
        text: this.$t("strings.delete_confirm"),
        accept: this.deleteOfficers,
      });
    },
    async getServices() {
      let input = {
        name: this.service,
      };
      let response = await this.getHTTPPostResponse("/services/list", input);
      if (response) {
        let service_req = response.data.services;
        let filteredServices = [];
        for (var i = 0; i < service_req.length; i++) {
          if (service_req[i].id === 1 || service_req[i].id === 2) {
            let obj = { id: service_req[i].id, name: service_req[i].name };
            filteredServices.push(obj);
          }
        }
        this.services_drop = filteredServices;
      }
    },
    async deleteOfficers() {
      if (this.index < 0) return;
      let index = this.index;
      let url = "qualifications/delete/" + this.officers[index].id;
      let ids = "";
      let input = {};
      let response = await this.getHTTPPostResponse(url, input, null, true);
      if (response) {
        await this.getOfficers();
      }
    },
    exportCsv() {
      this.getOfficers(true);
    },
    filter() {
      this.getOfficers();
    },
    clearFilter() {
      this.search = null;
      this.service = null;
      this.type = null;
      this.getOfficers();
    },
  },
};
</script>
<style scoped>
p {
  font-weight: 600;
}
</style>
